import React from 'react';
import styles from './cssf-subsection-progress.styles.css';
import { CprTooltip } from 'canopy-styleguide!sofe';
import { Link, withRouter } from 'react-router-dom';
import { navigate } from '../../source-forms/sections/section.helper';

export class SubsectionProgress extends React.Component {
  render() {
    const { props } = this;
    return (
      <div ref={this.createRef.bind(this)}>
        <CprTooltip
          html={props.subsection.name}
          disabled={!this.shouldShowTooltip.call(this)}>
          <Link
            to={props.subLink}
            style={{ textDecoration: 'none', outline: 'none' }}
            className={styles.subsectionLink}
            onClick={e =>
              navigate(props.surveyId, e, () =>
                props.history.push(props.subLink)
              )
            }>
            <div className={styles.subsection}>
              {props.subsection.completed ? (
                <i
                  style={{ fontSize: '32px' }}
                  className={`cps-color-success cps-icon cps-icon-sm-check`}
                />
              ) : (
                <img
                  style={{ width: '50%' }}
                  src="https://cdn.canopytax.com/static/end-user-forms-ui/GrayCircle.svg"
                />
              )}
            </div>
            <span
              className={`cps-ellipsis ${
                props.active ? 'cps-color-primary' : ''
              }`}>
              {props.subsection.name}
            </span>
          </Link>
        </CprTooltip>
      </div>
    );
  }
  shouldShowTooltip() {
    if (this.nameSpan) {
      // this detects if cps-ellipsis is actually causing ellipsis to be shown
      return this.nameSpan.scrollWidth > this.nameSpan.offsetWidth;
    } else {
      return false;
    }
  }
  createRef(el) {
    if (!el) {
      return;
    }
    this.nameSpan = el.querySelector(`.cps-ellipsis`);
  }
}

export default withRouter(SubsectionProgress);
